import { MoodStateOptions } from '@dataclouder/ngx-core';

export const getMoodStateLabelsAsString = (): string => {
  return MoodStateOptions.map((option) => option.value).join('\n');
};

export const MOOD_STATE_PROMPT = `
Analyze the provided conversation to identify the Assistant's mood, feelings, and emotions.
Return an array of 1 to 3 strings representing the Assistant's mood states, ordered from most to least relevant.
Each string must be one of the mood states listed below.

Example: ['guilty', 'ashamed', 'jealous']

${getMoodStateLabelsAsString()}
`;
